import moment from 'moment/moment'

export const transformDateTime = (dateTime: string | null) => {
  if (dateTime) {
    return moment(dateTime).format('MMM. DD, HH:mm:ss')
  }
  return ''
}
